// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","large":"1600px","desktop":"1366px","ipad":"1024px","ipad-portrait":"768px","mobile-l":"640px","wrapper":"_321HEx15o7vzbVGsG-pV_Y","rectangle":"_10SV4zOSMqf_0PvxR-lXkb","actionIcon":"_28QPzTuVwDclfGHWGsrdOM"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Banner/HeroBanner/TypeC/TypeC.css
// module id = 1397
// module chunks = 0